<template>
    <div class="container">
        <div class="row">
            <z-lead class="u-bottom-margin--m">{{ text.lead }}</z-lead>
            <z-figure
                class="team__figure"
                :caption="text.caption"
                image="/images/team/team.jpg"
            ></z-figure>
            <z-video class="team__video"
                v-if="this.lang === 'ru'"
                src="https://files.raspadskaya.com/files/video.mp4"
                poster="/images/team/preview_video.png">]
            </z-video>
            <template v-if="teamInfo.items && teamInfo.items.length">
                <z-caption class="team__title" tag="h2" size="2xl">{{ text.main }}</z-caption>
                <a
                    v-for="(person, index) in teamInfo.items"
                    :key="index"
                    class="team__link col-default-12"
                    :href="person.detailPageUrl || ''"
                >
                    <z-blockquote
                        link
                        size="s"
                        :author="{
                            name: person.name,
                            info: person.position.value,
                            photo: person.previewPicture.link || ''
                        }"
                        :text="person.quote.value"
                        :date="person.startOfWork.value"
                        :linkToDetail="person.detailPageUrl || ''"
                    />
                </a>
            </template>
        </div>
    </div>
</template>

<script>
import { text } from './constans.js'

export default {
    name: 'team',
    data () {
        return {
            teamInfo: this.$root.app.components['team'],
            text,
            lang: this.$root.lang
        }
    }
}
</script>

<style lang="scss">
.team {
    &__figure {
        .z-figure__caption {
            font-size: 30px;
            line-height: 150%;
            margin-bottom: $token-spacers-3-xl;
            margin-top: 32px;
            color: #2f2e34;
        }

        .z-figure__image {
            padding-top: 46%;
            max-height: 340px;
        }
    }

    &__video {
        margin-bottom: $token-spacers-3-xl;
    }

    &__title {
        margin-bottom: $token-spacers-l !important;
    }

    &__link {
        text-decoration: none;
        margin-bottom: 80px;
        display: block;
    }

    &__link {
        .z-blockquote__author-photo {
            margin-right: 32px;
        }

        .z-blockquote__name {
            margin-bottom: 12px;
        }

        .z-blockquote__info-container {
            margin-bottom: 12px;
        }

        .z-blockquote__author-photo {
            width: 140px;
        }
    }
}
</style>
